import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Charts} from '../components';
import {Insights} from '../components'
import {StrategyMapEd} from '../components/edComponents';
import {StrategyMapEdEnglish} from '../components/edComponents';
import {EdModal} from '../components/edComponents';
import {ChangeChartTitle} from '../components'
import CircularProgress from '@material-ui/core/CircularProgress';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, LabelList} from 'recharts';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    buttonColumn: {
      display: 'inline-block',
      textAlign: 'center',
      cursor: 'pointer',
    },
    lineButton: {
      justifyContent: 'space-between',
      display: 'flex',
      width: '1120px',
      transform: 'translateY(-10px)',
      'z-index': '100'

    },
    ButtonContener: {
      'align-items': 'center',
      display: 'inline',
      maxWidth: 75
      // width: '100%'

    },
    buttonRow: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      Zindex: 0
    },
    deleteRow: {
      'justify-content': 'space-between',
      display: 'flex',
      width: '300px'
    },
    seriesButton: {
      backgroundColor: theme.palette.background.paper,
      display: 'inline-block',
      width: '120%',
      textTransform: 'none'
    },
    h1: {
      display: 'inline'
    },
    head: {
      display: 'flex',
    },

}));

const colorButton = {
  0: '#ec407a',
  1: '#7e57c2',
  2: '#4caf50',
  3: '#ffeb3b',
  4: '#4caf50',
  5: '#ffeb3b',
}
const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 ${grid-6}px 0 0`,
  // minHeight: '100px',
  // overflow: 'hidden',
  width: '100%',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '#ececec',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#e1f5fe' : 'none',
  display: 'flex',
  padding: grid,

  textAlign: 'center',
  justifyContent: 'space-between',
  width: '1120px',
  // transform: 'translateY(0px)',
  overflow: 'hidden',
});
const reorder = (list, startIndex, endIndex, NewDroppableId) => {
    const result = Array.from(list);
    // // // console.log(result, 'result', startIndex, endIndex, NewDroppableId)
    // result[startIndex]['type'] = NewDroppableId
    const [removed] = result.splice(startIndex, 1);
    // // // console.log(removed, 'removed')
    result.splice(endIndex, 0, removed);

    return result;
};



function StrategyMapDetail({updateChart, selected, getDetailChart, match: {params: {projectId, chartId}}}) {

    const [openUpdateColumn, setOpenUpdateColumn] = React.useState(false);
    const [openUpdateRow, setOpenUpdateRow] = React.useState(false);
    const [values, setValues] = React.useState({
        title: '',
    });
    const [columnKey, setColumnKey] = React.useState({
        key: 0,
    });
    const [rowKey, setRowKey] = React.useState({
        key: 0,
    });



    const classes = useStyles();

    React.useEffect(() => {
        getDetailChart(projectId,chartId)
    }, [projectId,chartId]);

    if (!selected) {
        return (
            <div
              style={{
                width: '1000px',
                height: '700px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex'
              }}>
                <CircularProgress
                  style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                    }}/>
            </div>
        )
    }

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const clickColumnUpdate = (key) => {
      setOpenUpdateColumn(true)
      setColumnKey({
        key: key
        })
      }

    const handleClickUpdate = event => {
      // // // console.log([...selected.data.data][columnKey.key])

      selected.data.data[columnKey.key].title = values.title
      // // // console.log([...selected.data.data])

      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: selected.data.series,
        }})
      setOpenUpdateColumn(false)
      window.location.reload(false);
    }

    const columnClickDelete = key => {
      // {// // console.log(key)}
      const newData = [...selected.data.data]

      newData.splice(key,1)
      // {// // console.log(newData)}

      updateChart(projectId, chartId, {...selected, data: {
        data: newData,
        series: selected.data.series,
        }})
      setOpenUpdateColumn(false)

      setColumnKey({
        key: 0
      })


      window.location.reload(false);

    }

    const clickRowUpdate = key => {
      setOpenUpdateRow(true)
      setRowKey({
        key: key
        })
    }

    const handleClickUpdateRow = key => {
      // // console.log('handleClickUpdateRow')
      selected.data.data.forEach((item) => {
        item[values.title] = item[selected.data.series[rowKey.key]]
        delete item[selected.data.series[rowKey.key]]
      });
      // // // console.log(selected.data.data)
      selected.data.series[rowKey.key] = values.title



      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: selected.data.series,

        }})
      setOpenUpdateRow(false)
      window.location.reload(false);
    }

    const rowClickDelete = key => {
      // {// // console.log(key)}
      const newData = [...selected.data.series]

      newData.splice(key,1)
      // {// // console.log(newData)}

      window.location.reload(false);
      updateChart(projectId, chartId, {...selected, data: {
        data: selected.data.data,
        series: newData,

        }})
      setOpenUpdateRow(false)
      setRowKey({
        key: 0
      })
    }

    const onDragEnd = result => {
      const { source, destination } = result;
      // // // console.log('onDragEnd', result)

      if (destination != null) {
        const newData = reorder(
                  selected.data.data,
                  source.index,
                  destination.index,
                  destination.droppableId
              );
              // // // console.log('items',newData)
              // setValues({data: newData});
              updateChart(projectId, chartId, {...selected, data: {
                data: newData,
                series: selected.data.series,

              }})
      }
      window.location.reload(false);
    }
    const rowLength = selected.data.data.length
    const Yaxix = (obj) => {

      var number = selected.data.data[rowLength-1][obj]
      Object.values(selected.data.data[rowLength-1]).forEach((item, i) => {
        // // // console.log(item,'Difrent', item - number)
        const DifrtNumber = item - number
        if (DifrtNumber > 14) {
          // // // console.log('true 1', item - number, DifrtNumber > 14)
          // // // console.log(' ')

        } else {
          // // console.log('true 2')
          var number = 10
          // // console.log(' ')

        }

      });
      // // console.log('number',number)
      return `${(-number)*(414/100)+600}px`
    }

    return (

      <>

      <div
        className={classes.head}>
        <ChangeChartTitle
          selected={selected}
          projectId={projectId}
          chartId={chartId}
          title={<h1
            className={classes.h1}>As-is Strategy Canvas | {selected.title} </h1>}/>
        <EdModal
          TextRu={StrategyMapEd}
          TextEng={StrategyMapEdEnglish}/>
      </div>

        <Charts
          data={selected.data.data}
          series={selected.data.series}
          save={({data, series}) => updateChart(projectId, chartId, {data: {data, series}})}/>



        {selected.data.series && <>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
              droppableId="droppable"
              direction="horizontal">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                            {Object.values(selected.data.data).map(
                              (obj, key) => (
                                <Draggable
                                    key={obj.title}
                                    draggableId={obj.title}
                                    index={key}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps.style
                                            )}
                                            key={obj.title}
                                        >
                                              <div
                                                className={classes.ButtonContener}
                                                key={obj.title}>
                                                    <div
                                                      key={key}
                                                      className={classes.buttonColumn}
                                                      onClick={()=>clickColumnUpdate(key)}>
                                                              {obj.title}

                                                    </div>
                                              </div>
                                        </div>
                                    )}
                              </Draggable>
                          ))}

                      {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </>
        }



          {selected.data.series && <>
          <div
            className={classes.b}>
              {Object.values(selected.data.series).map(
                (obj, key) =>
                <div
                  className={classes.Button}
                  key={key}>
                    <div
                      key={key}
                      style={{
                        position: 'absolute',
                        top: `${(-key*15)*(414/100)+540}px`,
                        left: '1220px'
                      }}>
                          <Button
                            variant="contained"
                            className={classes.seriesButton}
                            onClick={()=>clickRowUpdate(key)}
                            style={{
                              backgroundColor: colorButton[key]
                            }}>
                            {obj}
                          </Button>
                    </div>
                </div>
              )}
            </div>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdateColumn}
              onClose={() => setOpenUpdateColumn(false)}
          >
              <div className={classes.paper}>
                {selected.data.data[columnKey.key] && <>
                  <h2 id="simple-modal-title2">Change name {selected.data.data[columnKey.key].title}</h2>
                    <form
                        className={classes.form}
                        noValidate autoComplete="off">
                        <TextField
                            id="title"
                            label="Name"
                            defaultValue={selected.data.data[columnKey.key].title}
                            onChange={handleChange('title')}/>
                    </form>
                    <br/>
                    <div
                      className={classes.deleteRow}>
                      <Button
                          variant="contained"
                          color="primary"
                          disabled={values.title.length === 0 ? true : false}
                          style={{
                            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                          onClick={() => handleClickUpdate()}>
                          Update
                      </Button>
                      <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => columnClickDelete(columnKey.key)}>
                          Delete
                      </Button>
                    </div>
                  </>
                }
              </div>
          </Modal>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdateRow}
              onClose={() => setOpenUpdateRow(false)}
          >
              <div className={classes.paper}>
                {selected.data.series[rowKey.key] && <>
                  <h2 id="simple-modal-title2">Change company name</h2>
                    <form
                        className={classes.form}
                        noValidate autoComplete="off">
                        <TextField
                            id="title"
                            label="Name"
                            defaultValue={selected.data.series[rowKey.key]}
                            onChange={handleChange('title')}/>
                    </form>
                    <br/>
                    <div
                      className={classes.deleteRow}>
                      <Button
                          variant="contained"
                          color="primary"
                          disabled={values.title.length === 0 ? true : false}
                          style={{
                            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                          onClick={() => handleClickUpdateRow()}>
                          Update
                      </Button>
                      <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => rowClickDelete(rowKey.key)}>
                          Delete
                      </Button>
                    </div>
                  </>
                }
              </div>
          </Modal>
          </>
          }


          <Insights
            selected={selected}
            projectId={projectId}
            chartId={chartId}/>

      </>
    )
}


const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(StrategyMapDetail)
